import KTLayoutFooter from 'assets/plugins/ktfooter';
import AppColors from 'general/constants/AppColors';
import AppConfigs from 'general/constants/AppConfigs';
import buildDate from 'general/constants/buildDate';
import UIHelper from 'general/helpers/UIHelper';
import { useEffect } from 'react';

function KT01Footer(props) {
  useEffect(() => {
    KTLayoutFooter.init('kt_footer');
  }, []);

  return (
    <div
      id="kt_footer"
      className="footer py-4 d-flex flex-lg-column bg-white"
      style={{ borderTop: '1px solid rgba(219, 223, 241, 1)' }}
    >
      <div className="container d-flex flex-column flex-md-row align-items-center justify-content-center">
        {/* copyright */}
        <div className="order-2 order-md-1">
          <span
            className="mr-2"
            style={UIHelper.buildFontStyle('500', '13px', AppColors.gray[600])}
          >
            {new Date().getFullYear()}©
          </span>
          <a
            className="hover-opacity-60"
            target="_blank"
            href="https://tmt-egreen.com/"
            style={UIHelper.buildFontStyle('700', '13px', AppColors.primary)}
          >
            TMT - EGREEN {AppConfigs.env.domainUrl.includes('-dev') ? '(DEV)' : ''}
            {process.env.NODE_ENV === 'production' && (
              <span>
                {!AppConfigs.env.domainUrl.includes('-dev')
                  ? (
                    <span>
                      {" "}({buildDate.productBuildDate})
                    </span>
                  )
                  : (
                    <span>
                      {" "}({buildDate.devBuildDate})
                    </span>
                  )}
              </span>
            )}
          </a>
        </div>
      </div>
    </div>
  );
}

export default KT01Footer;
